import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ComponentType } from '../types/enum';

interface Status {
  statusValue: string;
  statusState: string;
}
interface CableBurialData {
  id: number;
  messageTitle: string;
}

@Injectable({
  providedIn: 'root',
})
export class CableBurialService {
  constructor(private translateService: TranslateService) {}
  burialMessageList = [
    {
      id: 1,
      messageTitle: 'cable_burial_status#season_open_pending_assignment_status',
    },
    {
      id: 2,
      messageTitle:
        'cable_burial_status#season_open_assigned_to_contractor_status',
    },
    {
      id: 3,
      messageTitle:
        'cable_burial_status#season_open_permits_locates_requested_status',
    },
    {
      id: 4,
      messageTitle:
        'cable_burial_status#season_open_all_permits_locates_received_status',
    },
    {
      id: 5,
      messageTitle:
        'cable_burial_status#season_open_assigned_to_burial_crew_status',
    },
    {
      id: 6,
      messageTitle: 'cable_burial_status#season_open_work_completed_status',
    },
    {
      id: 7,
      messageTitle:
        'cable_burial_status#burial_closed_season_pending_assignment_status',
    },
    {
      id: 8,
      messageTitle:
        'cable_burial_status#burial_closed_season_assigned_to_contractor_status',
    },
    {
      id: 9,
      messageTitle:
        'cable_burial_status#burial_closed_season_permits_locates_requested_status',
    },
    {
      id: 10,
      messageTitle:
        'cable_burial_status#burial_closed_season_all_permits_locates_received_status',
    },
    {
      id: 11,
      messageTitle:
        'cable_burial_status#burial_closed_season_assigned_to_burial_crew_status',
    },
    {
      id: 12,
      messageTitle:
        'cable_burial_status#burial_closed_season_work_completed_status',
    },
    {
      id: 13,
      messageTitle: 'cable_burial_status#burial_closed_season_on_hold_status',
    },
    {
      id: 14,
      messageTitle: 'cable_burial_status#season_open_on_hold_other_status',
    },
    {
      id: 15,
      messageTitle: 'cable_burial_status#season_open_no_access_status',
    },
  ];

  createObjectForBurialComponent(
    burailData: CableBurialData,
    echo: any
  ): MessageComponent {
    const burialStatusMessage = this.translateService.instant('BURIAL_STATUS');
    let componentData;
    let currentStage = burialStatusMessage.find(
      (message) => message.STATUS_NAME === burailData.messageTitle
    )?.CURRENT_BURIAL_STATUS;
    const currentStatusIndex = burailData?.id;
    let burialSeasonClosed;

    const initialTitle = this.translateService.instant('BURIAL_STATUS_TITLE');
    const statusTitle = initialTitle[1].STATUS_TYPE;
    if (burailData.id > 6 && burailData.id < 13) {
      burialSeasonClosed = true;
      currentStage = this.getDefaultBurialClosedText('BURIAL_SEASON_CLOSED');
    }

    if (currentStatusIndex >= 13) {
      currentStage = this.getDefaultBurialClosedText('BURIAL_ON_HOLD');
      componentData = {
        burialTitle: this.translateService.instant('BURIAL_HEADER_TEXT'),
        burialAddress: echo?.addressID,
        currentStage: currentStage,
        statusTitle: statusTitle,
      };
    } else {
      const statusList = this.createStatusList(currentStatusIndex);
      componentData = {
        burialStage: this.translateService.instant('BURIAL_STATUS_TITLE'),
        burialTitle: this.translateService.instant('BURIAL_HEADER_TEXT'),
        burialClosedText: this.translateService.instant('BURIAL_SEASON_CLOSED'),
        burialAddress: echo?.addressID,
        statusList: statusList,
        currentStage: currentStage,
        statusTitle: statusTitle,
        currentStatusIndex:
          burailData?.id > 6 ? burailData?.id - 6 : burailData?.id,
        burialSeasonClosed: burialSeasonClosed,
      };
    }
    return {
      component: ComponentType.BurialStatusCardComponent,
      componentData: componentData,
    };
  }

  getDefaultBurialClosedText(key: string): string {
    return this.translateService.instant(key);
  }

  createStatusList(currentStatusIndex: number): Status[] {
    const numberOfStages = 6;
    const statusList: Status[] = [];
    const burialStatus = this.translateService.instant('BURIAL_STATUS');
    for (let i = 1; i <= numberOfStages; i++) {
      const status = {
        statusValue: burialStatus[i - 1]?.CURRENT_BURIAL_STATUS,
        statusState: 'INPROGRESS',
      };
      if (currentStatusIndex < 7) {
        if (i < currentStatusIndex) {
          status.statusState = 'COMPLETED';
        }
        if (i > currentStatusIndex) {
          status.statusState = 'DEFAULT';
        }
      } else {
        status.statusValue = burialStatus[i + 5]?.CURRENT_BURIAL_STATUS;
        status.statusState =
          i + 6 >= currentStatusIndex ? 'DEFAULT' : 'CLOSED_COMPLETE';
      }
      statusList.push(status);
    }

    return statusList;
  }

  checkIfBurailMessageTitleExist(messageTitle: string): CableBurialData {
    if (messageTitle) {
      return this.burialMessageList.find(
        (burialStatus) => burialStatus?.messageTitle === messageTitle
      );
    }
  }
}
